/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as TermsOfUseImport } from "./routes/terms-of-use"
import { Route as PrivacyPolicyImport } from "./routes/privacy-policy"
import { Route as HelpImport } from "./routes/help"
import { Route as ConfirmationImport } from "./routes/confirmation"
import { Route as SettingsRouteImport } from "./routes/settings/route"
import { Route as AuthRouteImport } from "./routes/auth/route"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated/route"
import { Route as IndexImport } from "./routes/index"
import { Route as ReceiptIndexImport } from "./routes/receipt/index"
import { Route as AuthIndexImport } from "./routes/auth/index"
import { Route as SettingsLanguageImport } from "./routes/settings/language"
import { Route as ReceiptReceiptIDImport } from "./routes/receipt/$receiptID"
import { Route as AuthVerifyImport } from "./routes/auth/verify"
import { Route as AuthResetPasswordImport } from "./routes/auth/reset-password"
import { Route as AuthForgotPasswordImport } from "./routes/auth/forgot-password"
import { Route as AuthCreateAccountImport } from "./routes/auth/create-account"
import { Route as QrQrLookupIDRouteImport } from "./routes/qr/$qrLookupID/route"
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account/route"
import { Route as QrQrLookupIDIndexImport } from "./routes/qr/$qrLookupID/index"
import { Route as AuthSignInIndexImport } from "./routes/auth/sign-in/index"
import { Route as AuthenticatedAccountIndexImport } from "./routes/_authenticated/account/index"
import { Route as QrQrLookupIDWelcomeImport } from "./routes/qr/$qrLookupID/welcome"
import { Route as QrQrLookupIDHelpImport } from "./routes/qr/$qrLookupID/help"
import { Route as AuthSignInSetNewPasswordImport } from "./routes/auth/sign-in/set-new-password"
import { Route as AuthenticatedAccountUpdatePasswordImport } from "./routes/_authenticated/account/update-password"
import { Route as AuthenticatedAccountPersonalInformationImport } from "./routes/_authenticated/account/personal-information"
import { Route as AuthenticatedAccountVehiclesRouteImport } from "./routes/_authenticated/account/vehicles/route"
import { Route as AuthenticatedAccountSavedPaymentMethodsRouteImport } from "./routes/_authenticated/account/saved-payment-methods/route"
import { Route as AuthenticatedAccountVehiclesIndexImport } from "./routes/_authenticated/account/vehicles/index"
import { Route as AuthenticatedAccountSavedPaymentMethodsIndexImport } from "./routes/_authenticated/account/saved-payment-methods/index"
import { Route as AuthenticatedAccountVehiclesEditImport } from "./routes/_authenticated/account/vehicles/edit"
import { Route as AuthenticatedAccountVehiclesCreateImport } from "./routes/_authenticated/account/vehicles/create"
import { Route as AuthenticatedAccountSavedPaymentMethodsAddImport } from "./routes/_authenticated/account/saved-payment-methods/add"
import { Route as QrQrLookupIDGatedPamIDRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/route"
import { Route as QrQrLookupIDGatedPamIDIndexImport } from "./routes/qr/$qrLookupID/gated/$pamID/index"
import { Route as QrQrLookupIDGatedRegisterLookUpImport } from "./routes/qr/$qrLookupID/gated/register/look-up"
import { Route as QrQrLookupIDGatedRegisterContactInfoImport } from "./routes/qr/$qrLookupID/gated/register/contact-info"
import { Route as QrQrLookupIDGatedRegisterSessionIDRouteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/route"
import { Route as QrQrLookupIDGatedPamIDSessionIDRouteImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/route"
import { Route as QrQrLookupIDGatedPamIDLookUpIndexImport } from "./routes/qr/$qrLookupID/gated/$pamID/look-up.index"
import { Route as QrQrLookupIDGatedPamIDSessionIDIndexImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/index"
import { Route as QrQrLookupIDGatedRegisterSessionIDPaymentStatusImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/payment-status"
import { Route as QrQrLookupIDGatedRegisterSessionIDExpressImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/express"
import { Route as QrQrLookupIDGatedRegisterSessionIDConfirmationImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/confirmation"
import { Route as QrQrLookupIDGatedRegisterSessionIDCompleteImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/complete"
import { Route as QrQrLookupIDGatedRegisterSessionIDCheckoutImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/checkout"
import { Route as QrQrLookupIDGatedRegisterSessionIDCartImport } from "./routes/qr/$qrLookupID/gated/register/$sessionID/cart"
import { Route as QrQrLookupIDGatedPamIDLookUpChallengeImport } from "./routes/qr/$qrLookupID/gated/$pamID/look-up.challenge"
import { Route as QrQrLookupIDGatedPamIDSessionIDPaymentStatusImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
import { Route as QrQrLookupIDGatedPamIDSessionIDCheckoutImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
import { Route as QrQrLookupIDGatedPamIDSessionIDCartImport } from "./routes/qr/$qrLookupID/gated/$pamID/$sessionID/cart"

// Create/Update Routes

const TermsOfUseRoute = TermsOfUseImport.update({
  id: "/terms-of-use",
  path: "/terms-of-use",
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  id: "/privacy-policy",
  path: "/privacy-policy",
  getParentRoute: () => rootRoute,
} as any)

const HelpRoute = HelpImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => rootRoute,
} as any)

const ConfirmationRoute = ConfirmationImport.update({
  id: "/confirmation",
  path: "/confirmation",
  getParentRoute: () => rootRoute,
} as any)

const SettingsRouteRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any)

const ReceiptIndexRoute = ReceiptIndexImport.update({
  id: "/receipt/",
  path: "/receipt/",
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthRouteRoute,
} as any)

const SettingsLanguageRoute = SettingsLanguageImport.update({
  id: "/language",
  path: "/language",
  getParentRoute: () => SettingsRouteRoute,
} as any)

const ReceiptReceiptIDRoute = ReceiptReceiptIDImport.update({
  id: "/receipt/$receiptID",
  path: "/receipt/$receiptID",
  getParentRoute: () => rootRoute,
} as any)

const AuthVerifyRoute = AuthVerifyImport.update({
  id: "/verify",
  path: "/verify",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCreateAccountRoute = AuthCreateAccountImport.update({
  id: "/create-account",
  path: "/create-account",
  getParentRoute: () => AuthRouteRoute,
} as any)

const QrQrLookupIDRouteRoute = QrQrLookupIDRouteImport.update({
  id: "/qr/$qrLookupID",
  path: "/qr/$qrLookupID",
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedAccountRouteRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const QrQrLookupIDIndexRoute = QrQrLookupIDIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)

const AuthSignInIndexRoute = AuthSignInIndexImport.update({
  id: "/sign-in/",
  path: "/sign-in/",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthenticatedAccountIndexRoute = AuthenticatedAccountIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedAccountRouteRoute,
} as any)

const QrQrLookupIDWelcomeRoute = QrQrLookupIDWelcomeImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)

const QrQrLookupIDHelpRoute = QrQrLookupIDHelpImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => QrQrLookupIDRouteRoute,
} as any)

const AuthSignInSetNewPasswordRoute = AuthSignInSetNewPasswordImport.update({
  id: "/sign-in/set-new-password",
  path: "/sign-in/set-new-password",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthenticatedAccountUpdatePasswordRoute =
  AuthenticatedAccountUpdatePasswordImport.update({
    id: "/update-password",
    path: "/update-password",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)

const AuthenticatedAccountPersonalInformationRoute =
  AuthenticatedAccountPersonalInformationImport.update({
    id: "/personal-information",
    path: "/personal-information",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)

const AuthenticatedAccountVehiclesRouteRoute =
  AuthenticatedAccountVehiclesRouteImport.update({
    id: "/vehicles",
    path: "/vehicles",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)

const AuthenticatedAccountSavedPaymentMethodsRouteRoute =
  AuthenticatedAccountSavedPaymentMethodsRouteImport.update({
    id: "/saved-payment-methods",
    path: "/saved-payment-methods",
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)

const AuthenticatedAccountVehiclesIndexRoute =
  AuthenticatedAccountVehiclesIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)

const AuthenticatedAccountSavedPaymentMethodsIndexRoute =
  AuthenticatedAccountSavedPaymentMethodsIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)

const AuthenticatedAccountVehiclesEditRoute =
  AuthenticatedAccountVehiclesEditImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)

const AuthenticatedAccountVehiclesCreateRoute =
  AuthenticatedAccountVehiclesCreateImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedAccountVehiclesRouteRoute,
  } as any)

const AuthenticatedAccountSavedPaymentMethodsAddRoute =
  AuthenticatedAccountSavedPaymentMethodsAddImport.update({
    id: "/add",
    path: "/add",
    getParentRoute: () => AuthenticatedAccountSavedPaymentMethodsRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDRouteRoute =
  QrQrLookupIDGatedPamIDRouteImport.update({
    id: "/gated/$pamID",
    path: "/gated/$pamID",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDIndexRoute =
  QrQrLookupIDGatedPamIDIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterLookUpRoute =
  QrQrLookupIDGatedRegisterLookUpImport.update({
    id: "/gated/register/look-up",
    path: "/gated/register/look-up",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterContactInfoRoute =
  QrQrLookupIDGatedRegisterContactInfoImport.update({
    id: "/gated/register/contact-info",
    path: "/gated/register/contact-info",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDRouteRoute =
  QrQrLookupIDGatedRegisterSessionIDRouteImport.update({
    id: "/gated/register/$sessionID",
    path: "/gated/register/$sessionID",
    getParentRoute: () => QrQrLookupIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDSessionIDRouteRoute =
  QrQrLookupIDGatedPamIDSessionIDRouteImport.update({
    id: "/$sessionID",
    path: "/$sessionID",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDLookUpIndexRoute =
  QrQrLookupIDGatedPamIDLookUpIndexImport.update({
    id: "/look-up/",
    path: "/look-up/",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDSessionIDIndexRoute =
  QrQrLookupIDGatedPamIDSessionIDIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute =
  QrQrLookupIDGatedRegisterSessionIDPaymentStatusImport.update({
    id: "/payment-status",
    path: "/payment-status",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDExpressRoute =
  QrQrLookupIDGatedRegisterSessionIDExpressImport.update({
    id: "/express",
    path: "/express",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDConfirmationRoute =
  QrQrLookupIDGatedRegisterSessionIDConfirmationImport.update({
    id: "/confirmation",
    path: "/confirmation",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDCompleteRoute =
  QrQrLookupIDGatedRegisterSessionIDCompleteImport.update({
    id: "/complete",
    path: "/complete",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDCheckoutRoute =
  QrQrLookupIDGatedRegisterSessionIDCheckoutImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedRegisterSessionIDCartRoute =
  QrQrLookupIDGatedRegisterSessionIDCartImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDGatedRegisterSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDLookUpChallengeRoute =
  QrQrLookupIDGatedPamIDLookUpChallengeImport.update({
    id: "/look-up/challenge",
    path: "/look-up/challenge",
    getParentRoute: () => QrQrLookupIDGatedPamIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute =
  QrQrLookupIDGatedPamIDSessionIDPaymentStatusImport.update({
    id: "/payment-status",
    path: "/payment-status",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDSessionIDCheckoutRoute =
  QrQrLookupIDGatedPamIDSessionIDCheckoutImport.update({
    id: "/checkout",
    path: "/checkout",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)

const QrQrLookupIDGatedPamIDSessionIDCartRoute =
  QrQrLookupIDGatedPamIDSessionIDCartImport.update({
    id: "/cart",
    path: "/cart",
    getParentRoute: () => QrQrLookupIDGatedPamIDSessionIDRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    "/auth": {
      id: "/auth"
      path: "/auth"
      fullPath: "/auth"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRoute
    }
    "/confirmation": {
      id: "/confirmation"
      path: "/confirmation"
      fullPath: "/confirmation"
      preLoaderRoute: typeof ConfirmationImport
      parentRoute: typeof rootRoute
    }
    "/help": {
      id: "/help"
      path: "/help"
      fullPath: "/help"
      preLoaderRoute: typeof HelpImport
      parentRoute: typeof rootRoute
    }
    "/privacy-policy": {
      id: "/privacy-policy"
      path: "/privacy-policy"
      fullPath: "/privacy-policy"
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    "/terms-of-use": {
      id: "/terms-of-use"
      path: "/terms-of-use"
      fullPath: "/terms-of-use"
      preLoaderRoute: typeof TermsOfUseImport
      parentRoute: typeof rootRoute
    }
    "/_authenticated/account": {
      id: "/_authenticated/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    "/qr/$qrLookupID": {
      id: "/qr/$qrLookupID"
      path: "/qr/$qrLookupID"
      fullPath: "/qr/$qrLookupID"
      preLoaderRoute: typeof QrQrLookupIDRouteImport
      parentRoute: typeof rootRoute
    }
    "/auth/create-account": {
      id: "/auth/create-account"
      path: "/create-account"
      fullPath: "/auth/create-account"
      preLoaderRoute: typeof AuthCreateAccountImport
      parentRoute: typeof AuthRouteImport
    }
    "/auth/forgot-password": {
      id: "/auth/forgot-password"
      path: "/forgot-password"
      fullPath: "/auth/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    "/auth/verify": {
      id: "/auth/verify"
      path: "/verify"
      fullPath: "/auth/verify"
      preLoaderRoute: typeof AuthVerifyImport
      parentRoute: typeof AuthRouteImport
    }
    "/receipt/$receiptID": {
      id: "/receipt/$receiptID"
      path: "/receipt/$receiptID"
      fullPath: "/receipt/$receiptID"
      preLoaderRoute: typeof ReceiptReceiptIDImport
      parentRoute: typeof rootRoute
    }
    "/settings/language": {
      id: "/settings/language"
      path: "/language"
      fullPath: "/settings/language"
      preLoaderRoute: typeof SettingsLanguageImport
      parentRoute: typeof SettingsRouteImport
    }
    "/auth/": {
      id: "/auth/"
      path: "/"
      fullPath: "/auth/"
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthRouteImport
    }
    "/receipt/": {
      id: "/receipt/"
      path: "/receipt"
      fullPath: "/receipt"
      preLoaderRoute: typeof ReceiptIndexImport
      parentRoute: typeof rootRoute
    }
    "/_authenticated/account/saved-payment-methods": {
      id: "/_authenticated/account/saved-payment-methods"
      path: "/saved-payment-methods"
      fullPath: "/account/saved-payment-methods"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteImport
      parentRoute: typeof AuthenticatedAccountRouteImport
    }
    "/_authenticated/account/vehicles": {
      id: "/_authenticated/account/vehicles"
      path: "/vehicles"
      fullPath: "/account/vehicles"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesRouteImport
      parentRoute: typeof AuthenticatedAccountRouteImport
    }
    "/_authenticated/account/personal-information": {
      id: "/_authenticated/account/personal-information"
      path: "/personal-information"
      fullPath: "/account/personal-information"
      preLoaderRoute: typeof AuthenticatedAccountPersonalInformationImport
      parentRoute: typeof AuthenticatedAccountRouteImport
    }
    "/_authenticated/account/update-password": {
      id: "/_authenticated/account/update-password"
      path: "/update-password"
      fullPath: "/account/update-password"
      preLoaderRoute: typeof AuthenticatedAccountUpdatePasswordImport
      parentRoute: typeof AuthenticatedAccountRouteImport
    }
    "/auth/sign-in/set-new-password": {
      id: "/auth/sign-in/set-new-password"
      path: "/sign-in/set-new-password"
      fullPath: "/auth/sign-in/set-new-password"
      preLoaderRoute: typeof AuthSignInSetNewPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    "/qr/$qrLookupID/help": {
      id: "/qr/$qrLookupID/help"
      path: "/help"
      fullPath: "/qr/$qrLookupID/help"
      preLoaderRoute: typeof QrQrLookupIDHelpImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/qr/$qrLookupID/welcome": {
      id: "/qr/$qrLookupID/welcome"
      path: "/welcome"
      fullPath: "/qr/$qrLookupID/welcome"
      preLoaderRoute: typeof QrQrLookupIDWelcomeImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/_authenticated/account/": {
      id: "/_authenticated/account/"
      path: "/"
      fullPath: "/account/"
      preLoaderRoute: typeof AuthenticatedAccountIndexImport
      parentRoute: typeof AuthenticatedAccountRouteImport
    }
    "/auth/sign-in/": {
      id: "/auth/sign-in/"
      path: "/sign-in"
      fullPath: "/auth/sign-in"
      preLoaderRoute: typeof AuthSignInIndexImport
      parentRoute: typeof AuthRouteImport
    }
    "/qr/$qrLookupID/": {
      id: "/qr/$qrLookupID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/"
      preLoaderRoute: typeof QrQrLookupIDIndexImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID": {
      id: "/qr/$qrLookupID/gated/$pamID"
      path: "/gated/$pamID"
      fullPath: "/qr/$qrLookupID/gated/$pamID"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDRouteImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/_authenticated/account/saved-payment-methods/add": {
      id: "/_authenticated/account/saved-payment-methods/add"
      path: "/add"
      fullPath: "/account/saved-payment-methods/add"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsAddImport
      parentRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteImport
    }
    "/_authenticated/account/vehicles/create": {
      id: "/_authenticated/account/vehicles/create"
      path: "/create"
      fullPath: "/account/vehicles/create"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesCreateImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteImport
    }
    "/_authenticated/account/vehicles/edit": {
      id: "/_authenticated/account/vehicles/edit"
      path: "/edit"
      fullPath: "/account/vehicles/edit"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesEditImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteImport
    }
    "/_authenticated/account/saved-payment-methods/": {
      id: "/_authenticated/account/saved-payment-methods/"
      path: "/"
      fullPath: "/account/saved-payment-methods/"
      preLoaderRoute: typeof AuthenticatedAccountSavedPaymentMethodsIndexImport
      parentRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteImport
    }
    "/_authenticated/account/vehicles/": {
      id: "/_authenticated/account/vehicles/"
      path: "/"
      fullPath: "/account/vehicles/"
      preLoaderRoute: typeof AuthenticatedAccountVehiclesIndexImport
      parentRoute: typeof AuthenticatedAccountVehiclesRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID"
      path: "/$sessionID"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID": {
      id: "/qr/$qrLookupID/gated/register/$sessionID"
      path: "/gated/register/$sessionID"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/contact-info": {
      id: "/qr/$qrLookupID/gated/register/contact-info"
      path: "/gated/register/contact-info"
      fullPath: "/qr/$qrLookupID/gated/register/contact-info"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterContactInfoImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/look-up": {
      id: "/qr/$qrLookupID/gated/register/look-up"
      path: "/gated/register/look-up"
      fullPath: "/qr/$qrLookupID/gated/register/look-up"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterLookUpImport
      parentRoute: typeof QrQrLookupIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/": {
      id: "/qr/$qrLookupID/gated/$pamID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/gated/$pamID/"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDIndexImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDCartImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDCheckoutImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
      path: "/payment-status"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/look-up/challenge": {
      id: "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
      path: "/look-up/challenge"
      fullPath: "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDLookUpChallengeImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/cart": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/cart"
      path: "/cart"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/cart"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCartImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/checkout": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/checkout"
      path: "/checkout"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/checkout"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCheckoutImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/complete": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/complete"
      path: "/complete"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/complete"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDCompleteImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/confirmation": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
      path: "/confirmation"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDConfirmationImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/express": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/express"
      path: "/express"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/express"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDExpressImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/register/$sessionID/payment-status": {
      id: "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
      path: "/payment-status"
      fullPath: "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
      preLoaderRoute: typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusImport
      parentRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/$sessionID/": {
      id: "/qr/$qrLookupID/gated/$pamID/$sessionID/"
      path: "/"
      fullPath: "/qr/$qrLookupID/gated/$pamID/$sessionID/"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDSessionIDIndexImport
      parentRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteImport
    }
    "/qr/$qrLookupID/gated/$pamID/look-up/": {
      id: "/qr/$qrLookupID/gated/$pamID/look-up/"
      path: "/look-up"
      fullPath: "/qr/$qrLookupID/gated/$pamID/look-up"
      preLoaderRoute: typeof QrQrLookupIDGatedPamIDLookUpIndexImport
      parentRoute: typeof QrQrLookupIDGatedPamIDRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren {
  AuthenticatedAccountSavedPaymentMethodsAddRoute: typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  AuthenticatedAccountSavedPaymentMethodsIndexRoute: typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
}

const AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren: AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren =
  {
    AuthenticatedAccountSavedPaymentMethodsAddRoute:
      AuthenticatedAccountSavedPaymentMethodsAddRoute,
    AuthenticatedAccountSavedPaymentMethodsIndexRoute:
      AuthenticatedAccountSavedPaymentMethodsIndexRoute,
  }

const AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren =
  AuthenticatedAccountSavedPaymentMethodsRouteRoute._addFileChildren(
    AuthenticatedAccountSavedPaymentMethodsRouteRouteChildren,
  )

interface AuthenticatedAccountVehiclesRouteRouteChildren {
  AuthenticatedAccountVehiclesCreateRoute: typeof AuthenticatedAccountVehiclesCreateRoute
  AuthenticatedAccountVehiclesEditRoute: typeof AuthenticatedAccountVehiclesEditRoute
  AuthenticatedAccountVehiclesIndexRoute: typeof AuthenticatedAccountVehiclesIndexRoute
}

const AuthenticatedAccountVehiclesRouteRouteChildren: AuthenticatedAccountVehiclesRouteRouteChildren =
  {
    AuthenticatedAccountVehiclesCreateRoute:
      AuthenticatedAccountVehiclesCreateRoute,
    AuthenticatedAccountVehiclesEditRoute:
      AuthenticatedAccountVehiclesEditRoute,
    AuthenticatedAccountVehiclesIndexRoute:
      AuthenticatedAccountVehiclesIndexRoute,
  }

const AuthenticatedAccountVehiclesRouteRouteWithChildren =
  AuthenticatedAccountVehiclesRouteRoute._addFileChildren(
    AuthenticatedAccountVehiclesRouteRouteChildren,
  )

interface AuthenticatedAccountRouteRouteChildren {
  AuthenticatedAccountSavedPaymentMethodsRouteRoute: typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  AuthenticatedAccountVehiclesRouteRoute: typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  AuthenticatedAccountPersonalInformationRoute: typeof AuthenticatedAccountPersonalInformationRoute
  AuthenticatedAccountUpdatePasswordRoute: typeof AuthenticatedAccountUpdatePasswordRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteRouteChildren: AuthenticatedAccountRouteRouteChildren =
  {
    AuthenticatedAccountSavedPaymentMethodsRouteRoute:
      AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren,
    AuthenticatedAccountVehiclesRouteRoute:
      AuthenticatedAccountVehiclesRouteRouteWithChildren,
    AuthenticatedAccountPersonalInformationRoute:
      AuthenticatedAccountPersonalInformationRoute,
    AuthenticatedAccountUpdatePasswordRoute:
      AuthenticatedAccountUpdatePasswordRoute,
    AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
  }

const AuthenticatedAccountRouteRouteWithChildren =
  AuthenticatedAccountRouteRoute._addFileChildren(
    AuthenticatedAccountRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAccountRouteRoute: typeof AuthenticatedAccountRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRouteRoute: AuthenticatedAccountRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthCreateAccountRoute: typeof AuthCreateAccountRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthSignInSetNewPasswordRoute: typeof AuthSignInSetNewPasswordRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCreateAccountRoute: AuthCreateAccountRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthSignInSetNewPasswordRoute: AuthSignInSetNewPasswordRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsLanguageRoute: typeof SettingsLanguageRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsLanguageRoute: SettingsLanguageRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren {
  QrQrLookupIDGatedPamIDSessionIDCartRoute: typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  QrQrLookupIDGatedPamIDSessionIDCheckoutRoute: typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute: typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  QrQrLookupIDGatedPamIDSessionIDIndexRoute: typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
}

const QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren: QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren =
  {
    QrQrLookupIDGatedPamIDSessionIDCartRoute:
      QrQrLookupIDGatedPamIDSessionIDCartRoute,
    QrQrLookupIDGatedPamIDSessionIDCheckoutRoute:
      QrQrLookupIDGatedPamIDSessionIDCheckoutRoute,
    QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute:
      QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute,
    QrQrLookupIDGatedPamIDSessionIDIndexRoute:
      QrQrLookupIDGatedPamIDSessionIDIndexRoute,
  }

const QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren =
  QrQrLookupIDGatedPamIDSessionIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedPamIDSessionIDRouteRouteChildren,
  )

interface QrQrLookupIDGatedPamIDRouteRouteChildren {
  QrQrLookupIDGatedPamIDSessionIDRouteRoute: typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  QrQrLookupIDGatedPamIDIndexRoute: typeof QrQrLookupIDGatedPamIDIndexRoute
  QrQrLookupIDGatedPamIDLookUpChallengeRoute: typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  QrQrLookupIDGatedPamIDLookUpIndexRoute: typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
}

const QrQrLookupIDGatedPamIDRouteRouteChildren: QrQrLookupIDGatedPamIDRouteRouteChildren =
  {
    QrQrLookupIDGatedPamIDSessionIDRouteRoute:
      QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren,
    QrQrLookupIDGatedPamIDIndexRoute: QrQrLookupIDGatedPamIDIndexRoute,
    QrQrLookupIDGatedPamIDLookUpChallengeRoute:
      QrQrLookupIDGatedPamIDLookUpChallengeRoute,
    QrQrLookupIDGatedPamIDLookUpIndexRoute:
      QrQrLookupIDGatedPamIDLookUpIndexRoute,
  }

const QrQrLookupIDGatedPamIDRouteRouteWithChildren =
  QrQrLookupIDGatedPamIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedPamIDRouteRouteChildren,
  )

interface QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren {
  QrQrLookupIDGatedRegisterSessionIDCartRoute: typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  QrQrLookupIDGatedRegisterSessionIDCheckoutRoute: typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  QrQrLookupIDGatedRegisterSessionIDCompleteRoute: typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  QrQrLookupIDGatedRegisterSessionIDConfirmationRoute: typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  QrQrLookupIDGatedRegisterSessionIDExpressRoute: typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute: typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
}

const QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren: QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren =
  {
    QrQrLookupIDGatedRegisterSessionIDCartRoute:
      QrQrLookupIDGatedRegisterSessionIDCartRoute,
    QrQrLookupIDGatedRegisterSessionIDCheckoutRoute:
      QrQrLookupIDGatedRegisterSessionIDCheckoutRoute,
    QrQrLookupIDGatedRegisterSessionIDCompleteRoute:
      QrQrLookupIDGatedRegisterSessionIDCompleteRoute,
    QrQrLookupIDGatedRegisterSessionIDConfirmationRoute:
      QrQrLookupIDGatedRegisterSessionIDConfirmationRoute,
    QrQrLookupIDGatedRegisterSessionIDExpressRoute:
      QrQrLookupIDGatedRegisterSessionIDExpressRoute,
    QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute:
      QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute,
  }

const QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren =
  QrQrLookupIDGatedRegisterSessionIDRouteRoute._addFileChildren(
    QrQrLookupIDGatedRegisterSessionIDRouteRouteChildren,
  )

interface QrQrLookupIDRouteRouteChildren {
  QrQrLookupIDHelpRoute: typeof QrQrLookupIDHelpRoute
  QrQrLookupIDWelcomeRoute: typeof QrQrLookupIDWelcomeRoute
  QrQrLookupIDIndexRoute: typeof QrQrLookupIDIndexRoute
  QrQrLookupIDGatedPamIDRouteRoute: typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  QrQrLookupIDGatedRegisterSessionIDRouteRoute: typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  QrQrLookupIDGatedRegisterContactInfoRoute: typeof QrQrLookupIDGatedRegisterContactInfoRoute
  QrQrLookupIDGatedRegisterLookUpRoute: typeof QrQrLookupIDGatedRegisterLookUpRoute
}

const QrQrLookupIDRouteRouteChildren: QrQrLookupIDRouteRouteChildren = {
  QrQrLookupIDHelpRoute: QrQrLookupIDHelpRoute,
  QrQrLookupIDWelcomeRoute: QrQrLookupIDWelcomeRoute,
  QrQrLookupIDIndexRoute: QrQrLookupIDIndexRoute,
  QrQrLookupIDGatedPamIDRouteRoute:
    QrQrLookupIDGatedPamIDRouteRouteWithChildren,
  QrQrLookupIDGatedRegisterSessionIDRouteRoute:
    QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren,
  QrQrLookupIDGatedRegisterContactInfoRoute:
    QrQrLookupIDGatedRegisterContactInfoRoute,
  QrQrLookupIDGatedRegisterLookUpRoute: QrQrLookupIDGatedRegisterLookUpRoute,
}

const QrQrLookupIDRouteRouteWithChildren =
  QrQrLookupIDRouteRoute._addFileChildren(QrQrLookupIDRouteRouteChildren)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "": typeof AuthenticatedRouteRouteWithChildren
  "/auth": typeof AuthRouteRouteWithChildren
  "/settings": typeof SettingsRouteRouteWithChildren
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/account": typeof AuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID": typeof QrQrLookupIDRouteRouteWithChildren
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/settings/language": typeof SettingsLanguageRoute
  "/auth/": typeof AuthIndexRoute
  "/receipt": typeof ReceiptIndexRoute
  "/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/account/vehicles": typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  "/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/welcome": typeof QrQrLookupIDWelcomeRoute
  "/account/": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID/": typeof QrQrLookupIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  "/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/account/saved-payment-methods/": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/account/vehicles/": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/gated/$pamID/": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "": typeof AuthenticatedRouteRouteWithChildren
  "/settings": typeof SettingsRouteRouteWithChildren
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/settings/language": typeof SettingsLanguageRoute
  "/auth": typeof AuthIndexRoute
  "/receipt": typeof ReceiptIndexRoute
  "/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/welcome": typeof QrQrLookupIDWelcomeRoute
  "/account": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID": typeof QrQrLookupIDIndexRoute
  "/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/account/vehicles": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexRoute
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren
  "/auth": typeof AuthRouteRouteWithChildren
  "/settings": typeof SettingsRouteRouteWithChildren
  "/confirmation": typeof ConfirmationRoute
  "/help": typeof HelpRoute
  "/privacy-policy": typeof PrivacyPolicyRoute
  "/terms-of-use": typeof TermsOfUseRoute
  "/_authenticated/account": typeof AuthenticatedAccountRouteRouteWithChildren
  "/qr/$qrLookupID": typeof QrQrLookupIDRouteRouteWithChildren
  "/auth/create-account": typeof AuthCreateAccountRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/receipt/$receiptID": typeof ReceiptReceiptIDRoute
  "/settings/language": typeof SettingsLanguageRoute
  "/auth/": typeof AuthIndexRoute
  "/receipt/": typeof ReceiptIndexRoute
  "/_authenticated/account/saved-payment-methods": typeof AuthenticatedAccountSavedPaymentMethodsRouteRouteWithChildren
  "/_authenticated/account/vehicles": typeof AuthenticatedAccountVehiclesRouteRouteWithChildren
  "/_authenticated/account/personal-information": typeof AuthenticatedAccountPersonalInformationRoute
  "/_authenticated/account/update-password": typeof AuthenticatedAccountUpdatePasswordRoute
  "/auth/sign-in/set-new-password": typeof AuthSignInSetNewPasswordRoute
  "/qr/$qrLookupID/help": typeof QrQrLookupIDHelpRoute
  "/qr/$qrLookupID/welcome": typeof QrQrLookupIDWelcomeRoute
  "/_authenticated/account/": typeof AuthenticatedAccountIndexRoute
  "/auth/sign-in/": typeof AuthSignInIndexRoute
  "/qr/$qrLookupID/": typeof QrQrLookupIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID": typeof QrQrLookupIDGatedPamIDRouteRouteWithChildren
  "/_authenticated/account/saved-payment-methods/add": typeof AuthenticatedAccountSavedPaymentMethodsAddRoute
  "/_authenticated/account/vehicles/create": typeof AuthenticatedAccountVehiclesCreateRoute
  "/_authenticated/account/vehicles/edit": typeof AuthenticatedAccountVehiclesEditRoute
  "/_authenticated/account/saved-payment-methods/": typeof AuthenticatedAccountSavedPaymentMethodsIndexRoute
  "/_authenticated/account/vehicles/": typeof AuthenticatedAccountVehiclesIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID": typeof QrQrLookupIDGatedPamIDSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/$sessionID": typeof QrQrLookupIDGatedRegisterSessionIDRouteRouteWithChildren
  "/qr/$qrLookupID/gated/register/contact-info": typeof QrQrLookupIDGatedRegisterContactInfoRoute
  "/qr/$qrLookupID/gated/register/look-up": typeof QrQrLookupIDGatedRegisterLookUpRoute
  "/qr/$qrLookupID/gated/$pamID/": typeof QrQrLookupIDGatedPamIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": typeof QrQrLookupIDGatedPamIDSessionIDCartRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": typeof QrQrLookupIDGatedPamIDSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": typeof QrQrLookupIDGatedPamIDSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/challenge": typeof QrQrLookupIDGatedPamIDLookUpChallengeRoute
  "/qr/$qrLookupID/gated/register/$sessionID/cart": typeof QrQrLookupIDGatedRegisterSessionIDCartRoute
  "/qr/$qrLookupID/gated/register/$sessionID/checkout": typeof QrQrLookupIDGatedRegisterSessionIDCheckoutRoute
  "/qr/$qrLookupID/gated/register/$sessionID/complete": typeof QrQrLookupIDGatedRegisterSessionIDCompleteRoute
  "/qr/$qrLookupID/gated/register/$sessionID/confirmation": typeof QrQrLookupIDGatedRegisterSessionIDConfirmationRoute
  "/qr/$qrLookupID/gated/register/$sessionID/express": typeof QrQrLookupIDGatedRegisterSessionIDExpressRoute
  "/qr/$qrLookupID/gated/register/$sessionID/payment-status": typeof QrQrLookupIDGatedRegisterSessionIDPaymentStatusRoute
  "/qr/$qrLookupID/gated/$pamID/$sessionID/": typeof QrQrLookupIDGatedPamIDSessionIDIndexRoute
  "/qr/$qrLookupID/gated/$pamID/look-up/": typeof QrQrLookupIDGatedPamIDLookUpIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | ""
    | "/auth"
    | "/settings"
    | "/confirmation"
    | "/help"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/account"
    | "/qr/$qrLookupID"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/settings/language"
    | "/auth/"
    | "/receipt"
    | "/account/saved-payment-methods"
    | "/account/vehicles"
    | "/account/personal-information"
    | "/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/welcome"
    | "/account/"
    | "/auth/sign-in"
    | "/qr/$qrLookupID/"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/account/saved-payment-methods/add"
    | "/account/vehicles/create"
    | "/account/vehicles/edit"
    | "/account/saved-payment-methods/"
    | "/account/vehicles/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/gated/$pamID/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/"
    | "/qr/$qrLookupID/gated/$pamID/look-up"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | ""
    | "/settings"
    | "/confirmation"
    | "/help"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/settings/language"
    | "/auth"
    | "/receipt"
    | "/account/personal-information"
    | "/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/welcome"
    | "/account"
    | "/auth/sign-in"
    | "/qr/$qrLookupID"
    | "/account/saved-payment-methods/add"
    | "/account/vehicles/create"
    | "/account/vehicles/edit"
    | "/account/saved-payment-methods"
    | "/account/vehicles"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/$pamID/look-up"
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/auth"
    | "/settings"
    | "/confirmation"
    | "/help"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/_authenticated/account"
    | "/qr/$qrLookupID"
    | "/auth/create-account"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/receipt/$receiptID"
    | "/settings/language"
    | "/auth/"
    | "/receipt/"
    | "/_authenticated/account/saved-payment-methods"
    | "/_authenticated/account/vehicles"
    | "/_authenticated/account/personal-information"
    | "/_authenticated/account/update-password"
    | "/auth/sign-in/set-new-password"
    | "/qr/$qrLookupID/help"
    | "/qr/$qrLookupID/welcome"
    | "/_authenticated/account/"
    | "/auth/sign-in/"
    | "/qr/$qrLookupID/"
    | "/qr/$qrLookupID/gated/$pamID"
    | "/_authenticated/account/saved-payment-methods/add"
    | "/_authenticated/account/vehicles/create"
    | "/_authenticated/account/vehicles/edit"
    | "/_authenticated/account/saved-payment-methods/"
    | "/_authenticated/account/vehicles/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID"
    | "/qr/$qrLookupID/gated/register/$sessionID"
    | "/qr/$qrLookupID/gated/register/contact-info"
    | "/qr/$qrLookupID/gated/register/look-up"
    | "/qr/$qrLookupID/gated/$pamID/"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/cart"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/look-up/challenge"
    | "/qr/$qrLookupID/gated/register/$sessionID/cart"
    | "/qr/$qrLookupID/gated/register/$sessionID/checkout"
    | "/qr/$qrLookupID/gated/register/$sessionID/complete"
    | "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
    | "/qr/$qrLookupID/gated/register/$sessionID/express"
    | "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
    | "/qr/$qrLookupID/gated/$pamID/$sessionID/"
    | "/qr/$qrLookupID/gated/$pamID/look-up/"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  ConfirmationRoute: typeof ConfirmationRoute
  HelpRoute: typeof HelpRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  QrQrLookupIDRouteRoute: typeof QrQrLookupIDRouteRouteWithChildren
  ReceiptReceiptIDRoute: typeof ReceiptReceiptIDRoute
  ReceiptIndexRoute: typeof ReceiptIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  ConfirmationRoute: ConfirmationRoute,
  HelpRoute: HelpRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  QrQrLookupIDRouteRoute: QrQrLookupIDRouteRouteWithChildren,
  ReceiptReceiptIDRoute: ReceiptReceiptIDRoute,
  ReceiptIndexRoute: ReceiptIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/auth",
        "/settings",
        "/confirmation",
        "/help",
        "/privacy-policy",
        "/terms-of-use",
        "/qr/$qrLookupID",
        "/receipt/$receiptID",
        "/receipt/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/account"
      ]
    },
    "/auth": {
      "filePath": "auth/route.tsx",
      "children": [
        "/auth/create-account",
        "/auth/forgot-password",
        "/auth/reset-password",
        "/auth/verify",
        "/auth/",
        "/auth/sign-in/set-new-password",
        "/auth/sign-in/"
      ]
    },
    "/settings": {
      "filePath": "settings/route.tsx",
      "children": [
        "/settings/language"
      ]
    },
    "/confirmation": {
      "filePath": "confirmation.tsx"
    },
    "/help": {
      "filePath": "help.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/terms-of-use": {
      "filePath": "terms-of-use.tsx"
    },
    "/_authenticated/account": {
      "filePath": "_authenticated/account/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/account/saved-payment-methods",
        "/_authenticated/account/vehicles",
        "/_authenticated/account/personal-information",
        "/_authenticated/account/update-password",
        "/_authenticated/account/"
      ]
    },
    "/qr/$qrLookupID": {
      "filePath": "qr/$qrLookupID/route.tsx",
      "children": [
        "/qr/$qrLookupID/help",
        "/qr/$qrLookupID/welcome",
        "/qr/$qrLookupID/",
        "/qr/$qrLookupID/gated/$pamID",
        "/qr/$qrLookupID/gated/register/$sessionID",
        "/qr/$qrLookupID/gated/register/contact-info",
        "/qr/$qrLookupID/gated/register/look-up"
      ]
    },
    "/auth/create-account": {
      "filePath": "auth/create-account.tsx",
      "parent": "/auth"
    },
    "/auth/forgot-password": {
      "filePath": "auth/forgot-password.tsx",
      "parent": "/auth"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx",
      "parent": "/auth"
    },
    "/auth/verify": {
      "filePath": "auth/verify.tsx",
      "parent": "/auth"
    },
    "/receipt/$receiptID": {
      "filePath": "receipt/$receiptID.tsx"
    },
    "/settings/language": {
      "filePath": "settings/language.tsx",
      "parent": "/settings"
    },
    "/auth/": {
      "filePath": "auth/index.tsx",
      "parent": "/auth"
    },
    "/receipt/": {
      "filePath": "receipt/index.tsx"
    },
    "/_authenticated/account/saved-payment-methods": {
      "filePath": "_authenticated/account/saved-payment-methods/route.tsx",
      "parent": "/_authenticated/account",
      "children": [
        "/_authenticated/account/saved-payment-methods/add",
        "/_authenticated/account/saved-payment-methods/"
      ]
    },
    "/_authenticated/account/vehicles": {
      "filePath": "_authenticated/account/vehicles/route.tsx",
      "parent": "/_authenticated/account",
      "children": [
        "/_authenticated/account/vehicles/create",
        "/_authenticated/account/vehicles/edit",
        "/_authenticated/account/vehicles/"
      ]
    },
    "/_authenticated/account/personal-information": {
      "filePath": "_authenticated/account/personal-information.tsx",
      "parent": "/_authenticated/account"
    },
    "/_authenticated/account/update-password": {
      "filePath": "_authenticated/account/update-password.tsx",
      "parent": "/_authenticated/account"
    },
    "/auth/sign-in/set-new-password": {
      "filePath": "auth/sign-in/set-new-password.tsx",
      "parent": "/auth"
    },
    "/qr/$qrLookupID/help": {
      "filePath": "qr/$qrLookupID/help.tsx",
      "parent": "/qr/$qrLookupID"
    },
    "/qr/$qrLookupID/welcome": {
      "filePath": "qr/$qrLookupID/welcome.tsx",
      "parent": "/qr/$qrLookupID"
    },
    "/_authenticated/account/": {
      "filePath": "_authenticated/account/index.tsx",
      "parent": "/_authenticated/account"
    },
    "/auth/sign-in/": {
      "filePath": "auth/sign-in/index.tsx",
      "parent": "/auth"
    },
    "/qr/$qrLookupID/": {
      "filePath": "qr/$qrLookupID/index.tsx",
      "parent": "/qr/$qrLookupID"
    },
    "/qr/$qrLookupID/gated/$pamID": {
      "filePath": "qr/$qrLookupID/gated/$pamID/route.tsx",
      "parent": "/qr/$qrLookupID",
      "children": [
        "/qr/$qrLookupID/gated/$pamID/$sessionID",
        "/qr/$qrLookupID/gated/$pamID/",
        "/qr/$qrLookupID/gated/$pamID/look-up/challenge",
        "/qr/$qrLookupID/gated/$pamID/look-up/"
      ]
    },
    "/_authenticated/account/saved-payment-methods/add": {
      "filePath": "_authenticated/account/saved-payment-methods/add.tsx",
      "parent": "/_authenticated/account/saved-payment-methods"
    },
    "/_authenticated/account/vehicles/create": {
      "filePath": "_authenticated/account/vehicles/create.tsx",
      "parent": "/_authenticated/account/vehicles"
    },
    "/_authenticated/account/vehicles/edit": {
      "filePath": "_authenticated/account/vehicles/edit.tsx",
      "parent": "/_authenticated/account/vehicles"
    },
    "/_authenticated/account/saved-payment-methods/": {
      "filePath": "_authenticated/account/saved-payment-methods/index.tsx",
      "parent": "/_authenticated/account/saved-payment-methods"
    },
    "/_authenticated/account/vehicles/": {
      "filePath": "_authenticated/account/vehicles/index.tsx",
      "parent": "/_authenticated/account/vehicles"
    },
    "/qr/$qrLookupID/gated/$pamID/$sessionID": {
      "filePath": "qr/$qrLookupID/gated/$pamID/$sessionID/route.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID",
      "children": [
        "/qr/$qrLookupID/gated/$pamID/$sessionID/cart",
        "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout",
        "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status",
        "/qr/$qrLookupID/gated/$pamID/$sessionID/"
      ]
    },
    "/qr/$qrLookupID/gated/register/$sessionID": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/route.tsx",
      "parent": "/qr/$qrLookupID",
      "children": [
        "/qr/$qrLookupID/gated/register/$sessionID/cart",
        "/qr/$qrLookupID/gated/register/$sessionID/checkout",
        "/qr/$qrLookupID/gated/register/$sessionID/complete",
        "/qr/$qrLookupID/gated/register/$sessionID/confirmation",
        "/qr/$qrLookupID/gated/register/$sessionID/express",
        "/qr/$qrLookupID/gated/register/$sessionID/payment-status"
      ]
    },
    "/qr/$qrLookupID/gated/register/contact-info": {
      "filePath": "qr/$qrLookupID/gated/register/contact-info.tsx",
      "parent": "/qr/$qrLookupID"
    },
    "/qr/$qrLookupID/gated/register/look-up": {
      "filePath": "qr/$qrLookupID/gated/register/look-up.tsx",
      "parent": "/qr/$qrLookupID"
    },
    "/qr/$qrLookupID/gated/$pamID/": {
      "filePath": "qr/$qrLookupID/gated/$pamID/index.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID"
    },
    "/qr/$qrLookupID/gated/$pamID/$sessionID/cart": {
      "filePath": "qr/$qrLookupID/gated/$pamID/$sessionID/cart.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID/$sessionID"
    },
    "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout": {
      "filePath": "qr/$qrLookupID/gated/$pamID/$sessionID/checkout.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID/$sessionID"
    },
    "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status": {
      "filePath": "qr/$qrLookupID/gated/$pamID/$sessionID/payment-status.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID/$sessionID"
    },
    "/qr/$qrLookupID/gated/$pamID/look-up/challenge": {
      "filePath": "qr/$qrLookupID/gated/$pamID/look-up.challenge.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/cart": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/cart.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/checkout": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/checkout.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/complete": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/complete.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/confirmation": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/confirmation.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/express": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/express.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/register/$sessionID/payment-status": {
      "filePath": "qr/$qrLookupID/gated/register/$sessionID/payment-status.tsx",
      "parent": "/qr/$qrLookupID/gated/register/$sessionID"
    },
    "/qr/$qrLookupID/gated/$pamID/$sessionID/": {
      "filePath": "qr/$qrLookupID/gated/$pamID/$sessionID/index.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID/$sessionID"
    },
    "/qr/$qrLookupID/gated/$pamID/look-up/": {
      "filePath": "qr/$qrLookupID/gated/$pamID/look-up.index.tsx",
      "parent": "/qr/$qrLookupID/gated/$pamID"
    }
  }
}
ROUTE_MANIFEST_END */
